import useShopStore from '@/stores/shop';
import { computed } from 'vue';

const useCurrentShop = () => {
  const shopStore = useShopStore();
  return computed(() => shopStore.shop);
};

export default useCurrentShop;
